import { render, staticRenderFns } from "./DettaglioNews.vue?vue&type=template&id=41da5784&"
import script from "./DettaglioNews.vue?vue&type=script&lang=js&"
export * from "./DettaglioNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports